"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api/activity-api"), exports);
__exportStar(require("./api/calendar-api"), exports);
__exportStar(require("./api/client-api"), exports);
__exportStar(require("./api/dashboard-api"), exports);
__exportStar(require("./api/document-api"), exports);
__exportStar(require("./api/exact-controller-api"), exports);
__exportStar(require("./api/global-api"), exports);
__exportStar(require("./api/inventory-api"), exports);
__exportStar(require("./api/lead-api"), exports);
__exportStar(require("./api/lead-cost-api"), exports);
__exportStar(require("./api/lead-external-api"), exports);
__exportStar(require("./api/location-api"), exports);
__exportStar(require("./api/movetex-api"), exports);
__exportStar(require("./api/office365-api"), exports);
__exportStar(require("./api/planning-item-api"), exports);
__exportStar(require("./api/planning-item-comment-api"), exports);
__exportStar(require("./api/planning-item-report-api"), exports);
__exportStar(require("./api/product-api"), exports);
__exportStar(require("./api/quote-api"), exports);
__exportStar(require("./api/quote-comment-api"), exports);
__exportStar(require("./api/release-notes-api"), exports);
__exportStar(require("./api/stock-movements-api"), exports);
__exportStar(require("./api/storage-api"), exports);
__exportStar(require("./api/tenant-settings-api"), exports);
__exportStar(require("./api/user-api"), exports);
__exportStar(require("./api/work-order-api"), exports);
__exportStar(require("./api/work-order-comment-api"), exports);
